import { lazy } from "react"
import {
  CROP_PLANTING_CALENDARS_LIST_VIEW,
  CROP_PLANTING_CALENDAR_VIEW,
} from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllCropPlantingCalendars = lazy(
  () =>
    import(
      "@/features/crop-planting-calendar/views/all-crop-planting-calendars/all-crop-planting-calendars.tsx"
    ),
)
const CropPlantingCalendarView = lazy(
  () =>
    import(
      "@/features/crop-planting-calendar/views/crop-planting-calendar-view/crop-planting-calendar-view.tsx"
    ),
)

export const cropPlantingCalendarRoutes = [
  {
    path: CROP_PLANTING_CALENDARS_LIST_VIEW,
    element: <AllCropPlantingCalendars />,
  },
  {
    path: CROP_PLANTING_CALENDAR_VIEW,
    element: <CropPlantingCalendarView />,
  },
]

const DESKTOP_CROP_PLANTING_CALENDAR_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: cropPlantingCalendarRoutes,
  },
]

const MOBILE_CROP_PLANTING_CALENDAR_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: cropPlantingCalendarRoutes,
  },
]

export const getCropPlantingCalendarRoutes = (isDesktop: boolean) => {
  return isDesktop
    ? DESKTOP_CROP_PLANTING_CALENDAR_ROUTES
    : MOBILE_CROP_PLANTING_CALENDAR_ROUTES
}
